<script setup>
import { inject, ref, computed, defineProps } from 'vue';

const mq = inject(['mq']);

const props = defineProps({
    headPrimary: {
        type: Boolean,
        default: false
    },
    onlySp: {
        type: Boolean,
        default: false
    },
});

const isActive = ref(false);

// 状態管理
const toggleActive = () => {
    if (props.onlySp && mq.mdPlus) return;
    isActive.value = !isActive.value;
}

// アコーディオンを開くかどうか
const open = computed(() => {
    if (isActive.value || (props.onlySp && mq.mdPlus)) return true;
    return false;
});

// 開閉アニメーション
const doWhenActive = (el) => {
    el.style.height = el.scrollHeight + 'px';
}
const doWhenInactive = (el) => {
    el.style.height = '0';
}

</script>

<template>
<div class="accordion" :class="{ 'is-active': open }">
    <div class="accordion__head" :class="{'is-primary': headPrimary, 'is-only-sp': onlySp}" @click="toggleActive">
        <slot name="head"></slot>
        <div
        v-if="!onlySp || (onlySp && !mq.mdPlus)"
        class="acco-icon accordion__icon"
        :class="{ 'is-active': isActive, 'is-large': headPrimary }"></div>
    </div>
    <transition @before-enter="doWhenInactive" @enter="doWhenActive" @before-leave="doWhenActive" @leave="doWhenInactive">
        <div class="accordion__body" v-show="open">
            <slot name="body"></slot> 
        </div>
    </transition>
</div>
</template>